export const ACTIONS_OPTIONS = [
  { label: "Ver anexos", value: "ver_anexos" },
  { label: "Ver comentarios", value: "ver_comentarios" },
];

export const INITIAL_FORM_DATA = {
  numeroIngreso: "",
  fechaInicio: "",
  fechaFin: "",
};

export const ITEMS_PER_PAGE = 100;

export const TAMANO_PAGINA_ANEXOS = 10;

export const MODAL_ANEXOS_MAX_WIDTH = "600px";

